import { RouterProvider } from 'react-router-dom';
import { router } from '@/app/router';
import { MockProvider } from '@/mocks';

// MockProvider 包在 RouterProvider 外面：scenario 是整頁層級的驗證開關（§16.2），
// 讀的是 window.location.search，不需要、也不該綁在某個 route 底下。
export function App() {
  return (
    <MockProvider>
      <RouterProvider router={router} />
    </MockProvider>
  );
}
